/**
 * Uploads an image to the backend server, which then uploads it to Cloudinary.
 */
export async function uploadImage(file) {
  const formData = new FormData();
  formData.append('image', file); // Backend expects 'image' field

  try {
    const API_URL = window.location.hostname === 'localhost' 
      ? 'http://localhost:5000/upload' 
      : 'https://mediumpurple-squirrel-426661.hostingersite.com/upload';
      
    const response = await fetch(API_URL, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Upload failed');
    }
    
    const data = await response.json();
    console.log('Upload successful via backend:', data.url);
    return data.url; // This should be the Cloudinary secure URL
  } catch (error) {
    console.error('Upload Error:', error);
    alert('Upload failed: ' + error.message + '\nURL: ' + API_URL);
    throw error;
  }
}
